import type { ApprovalStatus } from '../../types/admin';

interface ApprovalStatusBadgeProps {
  status?: ApprovalStatus | null;
}

const getStatusClassName = (status?: ApprovalStatus | null) => {
  switch ((status || '').toLowerCase()) {
    case 'approved':
      return 'bg-green-100 text-green-700';
    case 'rejected':
      return 'bg-red-100 text-red-700';
    case 'cancelled':
      return 'bg-gray-100 text-gray-600';
    case 'pending':
    default:
      return 'bg-yellow-100 text-yellow-800';
  }
};

export default function ApprovalStatusBadge({ status }: ApprovalStatusBadgeProps) {
  const label = status || 'Pending';

  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${getStatusClassName(status)}`}>
      {label}
    </span>
  );
}
